import { Megaphone } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { CampaignManager } from "./CampaignManager";

export function CampaignsPage() {
  return (
    <div>
      <PageHeader
        icon={Megaphone}
        title="Campaigns"
        description="Plan and run coordinated content campaigns with defined goals, timelines, budgets, and team assignments. Track each campaign's progress from brief to final post."
      />
      <CampaignManager showHeader={false} />
    </div>
  );
}
